import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/PageHeader";
import DashboardHero from "./fragment/DashboardHero";
import DashboardPriorityPanel from "./fragment/DashboardPriorityPanel";
import DashboardTimeline from "./fragment/DashboardTimeline";
import {
  dashboardStats,
  dashboardScopeCards,
  dashboardPriorities,
  dashboardTimeline,
  dashboardHero,
} from "./mockData";
import DashboardStatCards from "./fragment/DashboardStatCards";
import DashboardScopeGrid from "./fragment/DashboardScopeGrid";

const DashboardPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-[#F8F8F8] min-h-screen p-0">
      <div className="max-w-7xl  px-4 py-8 space-y-8">
        <PageHeader title={t("dashboard")} />

        {/* Hero Section */}
        <div className="mb-4">
          <DashboardHero
            title={dashboardHero.title}
            description={dashboardHero.description}
            highlightedCounts={dashboardHero.highlightedCounts}
          />
        </div>

        {/* Statistics Cards */}
        <div className="mb-4">
          <DashboardStatCards stats={dashboardStats} />
        </div>

        {/* Main Content: Scope Grid & Priority Panel */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8 items-stretch">
          <div className="xl:col-span-2 flex flex-col h-full min-h-full">
            <DashboardScopeGrid scopes={dashboardScopeCards} />
          </div>
          <div className="flex flex-col h-full min-h-full">
            <DashboardPriorityPanel priorities={dashboardPriorities} />
          </div>
        </div>

        {/* Timeline */}
        <div className="mt-8">
          <DashboardTimeline timeline={dashboardTimeline} />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
